var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.condition)?_c('div',_vm._b({class:_vm.noBorder ? '' : 'conditional-group'},'div',_vm.testid && { 'data-testid': _vm.testid + 'test' },false),[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }